import { EDatasetColorTypes } from '../types/internal';
import { colors } from '../constants/colors';
import { BASE_DATASET_CFG } from './baseChartConfigParts';
import { getCanvasGradient } from './getCanvasGradient';

/**
 * Утилита служит для конфигурации датасетов для графика chart.js
 * */
export var defineDataset = function defineDataset(params) {
  return function (ctx, options) {
    var datasetCfg = Object.assign({}, BASE_DATASET_CFG, params.customChartOptions);
    datasetCfg.data = params.data;
    if (params.color) {
      var mainColor = colors[params.color]['100'];
      datasetCfg.borderColor = mainColor;
      datasetCfg.pointBackgroundColor = mainColor;
      datasetCfg.backgroundColor = colors[params.color]['24'];
      if (params.colorType === EDatasetColorTypes.GRADIENT) {
        datasetCfg.backgroundColor = getCanvasGradient({
          ctx: ctx,
          chartHeight: options.chartHeight,
          stopColors: [{
            offset: 0.5,
            color: colors[params.color]['24']
          }, {
            offset: 1,
            color: colors[params.color]['0']
          }]
        });
      } else if (params.colorType === EDatasetColorTypes.SOLID) {
        datasetCfg.backgroundColor = colors[params.color]['100'];
      } else if (params.colorType === EDatasetColorTypes.TRANSPARENT) {
        datasetCfg.backgroundColor = colors['TRANSPARENT'];
      }
    }
    if (params.withPoints) {
      datasetCfg.pointRadius = 3;
      datasetCfg.pointHoverRadius = 4;
    }
    if (params.dashed) {
      datasetCfg.borderDash = [2];
    }
    return datasetCfg;
  };
};